import clsx from 'clsx';

export type InputProps = {
  label?: string;
  name: string;
  className?: string;
  rows?: number;
  resizeable?: 'none' | 'both' | 'horizontal' | 'vertical';
  inputRef?: React.RefObject<HTMLTextAreaElement | null>;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export function TextArea({
  label,
  name,
  className,
  rows = 3,
  required,
  resizeable = 'none',
  inputRef,
  ...rest
}: InputProps) {
  const inputElement = (
    <textarea
      rows={rows}
      name={name}
      className={clsx('rounded-md px-4 py-[14px] placeholder:text-gray-4', className)}
      style={{ resize: resizeable }}
      required={required}
      ref={inputRef}
      {...rest}
    />
  );

  if (!label) {
    return inputElement;
  }

  return (
    <label className="flex w-full flex-col gap-3">
      {label} {required && '*'}
      {inputElement}
    </label>
  );
}
